import RandomDogService from './RandomDogService';
import { DogMedia } from './DogMedia';

export default RandomDogService;
export type { DogMedia };
